import { ReactText } from 'react';
import {
  StringValueKeyOption,
  BasicStringValueOption,
  BasicNumberValueOption,
  StringValueFieldOption,
} from '@minecraft.typings';
import { Feature, ProfileUnionFilter, Role } from '@minecraft.graphql-operations';

export enum FiltersNameEnum {
  autofillByRoleCriteria = 'autofillByRoleCriteria',
  stageName = 'stageName',
  search = 'search',
  series = 'series',
  role = 'role',
  unrepresented = 'unrepresented',
  represented = 'represented',
  talentType = 'talentType',
  profileType = 'profileType',
  representativeList = 'representativeList',
  representatives = 'representatives',
  nonUnion = 'nonUnion',
  unionStatus = 'unionStatus',
  excludeUnionStatus = 'excludeUnionStatus',
  gender = 'gender',
  additionallyIdentifiesAs = 'additionallyIdentifiesAs',
  castingDirector = 'castingDirector',
  ethnicAppearance = 'ethnicAppearance',
  playableAgeRange = 'playableAgeRange',
  minorsAgeRange = 'minorsAgeRange',
  realAgeRange = 'realAgeRange',
  profileStatus = 'profileStatus',
  projectTypes = 'projectTypes',
  projectStatus = 'projectStatus',
  workingLocation = 'workingLocation',
  primaryWorkingLocation = 'primaryWorkingLocation',
  additionalWorkingLocation = 'additionalWorkingLocation',
  workPermitExpiration = 'workPermitExpiration',
  heightRange = 'heightRange',
  weightRange = 'weightRange',
  selectionTag = 'selectionTag',
  submissionStatus = 'submissionStatus',
  scheduleList = 'scheduleList',
  scheduleId = 'scheduleId',
  scheduleResponse = 'scheduleResponse',
  scheduleStatus = 'scheduleStatus',
  seekingRepresentation = 'seekingRepresentation',
  sessionList = 'sessionList',
  sorting = 'sorting',
  presentationList = 'presentationList',
  slotDateRange = 'slotDateRange',
  hasPicks = 'hasPicks',
  hasComments = 'hasComments',
  isNewTalent = 'isNewTalent',
  hairColor = 'hairColor',
  willingToHairColor = 'willingToHairColor',
  hairStyle = 'hairStyle',
  willingToHairStyle = 'willingToHairStyle',
  facialHair = 'facialHair',
  willingToFacialHair = 'willingToFacialHair',
  eyeColor = 'eyeColor',
  tattoos = 'tattoos',
  tattoosList = 'tattoosList',
  tattoosNote = 'tattoosNote',
  piercings = 'piercings',
  piercingsList = 'piercingsList',
  piercingsNote = 'piercingsNote',
  uniqueAttributes = 'uniqueAttributes',
  multipleBirth = 'multipleBirth',
  otherExperience = 'otherExperience',
  pregnancyDueDateRange = 'pregnancyDueDateRange',
  // Exclude Talent With
  excludeConflicts = 'excludeConflicts',
  excludeBookedOutDates = 'excludeBookedOutDates',
  // Role Presferences
  rolePreferences = 'rolePreferences',
  // Clothing sizes
  sizesCategory = 'sizesCategory',
  sizesChildrenCategory = 'sizesChildrenCategory',
  chest = 'chest',
  neck = 'neck',
  sleeve = 'sleeve',
  coat = 'coat',
  waist = 'waist',
  menTShirt = 'menTShirt',
  inseam = 'inseam',
  glove = 'glove',
  hat = 'hat',
  menShoes = 'menShoes',
  menShoeWidth = 'menShoeWidth',
  dress = 'dress',
  bust = 'bust',
  underbust = 'underbust',
  cup = 'cup',
  hip = 'hip',
  womenPants = 'womenPants',
  womenTShirt = 'womenTShirt',
  womenShoes = 'womenShoes',
  womenShoeWidth = 'womenShoeWidth',
  boys = 'boys',
  girls = 'girls',
  toddlers = 'toddlers',
  infants = 'infants',
  childrenShoes = 'childrenShoes',
  childrenShoeWidth = 'childrenShoeWidth',
  // Skills And Assets
  skills = 'skills',
  skillLevels = 'skillLevels',
  skillOperator = 'skillOperator',
  dogBreed = 'dogBreed',
  dogBreedSize = 'dogBreedSize',
  otherAnimals = 'otherAnimals',
  props = 'props',
  sportsEquipment = 'sportsEquipment',
  wardrobe = 'wardrobe',
  profession = 'profession',
  vehicleType = 'vehicleType',
  vehicleYearRange = 'vehicleYearRange',
  vehicleMake = 'vehicleMake',
  vehicleModel = 'vehicleModel',
  // Documents
  documents = 'documents',
  // Child fields for range
  switchTo = 'switchTo',
  min = 'min',
  max = 'max',
  // Assistant union status fields
  sagAftraChildren = 'sagAftraChildren',
  // Child of Tattoos and Percings
  list = 'list',
  note = 'note',
  profileListIds = 'profileListIds',
  // Presentation Grid View filters
  folder = 'folder',
  commentedBy = 'commentedBy',
  pickedBy = 'pickedBy',
  // Reps worksheet
  requestType = 'requestType',
  requestStatus = 'requestStatus',
  projectName = 'projectName',
  talent = 'talent',
  viewByDate = 'viewByDate',
  dueRange = 'dueRange',
  receivedRange = 'receivedRange',
  // Child fields for search by
  inputValue = 'inputValue',
  options = 'options',
  date = 'date',
  luminate = 'luminate',
  hasCover = 'hasCover',
}

export enum RangeEnum {
  age = 'age',
  date = 'date',
  height = 'height',
  weight = 'weight',
  size = 'size',
}

export enum UnitSystemEnum {
  feetAndInches = 'ft and in',
  pounds = 'lbs',
  centimeters = 'cm',
  kilograms = 'kg',
  inches = 'in',
}

export enum UnitSystemNameEnum {
  kilogramsRounded = 'kgRounded',
  pounds = 'IMPERIAL_LBS',
  centimeters = 'METRIC_CENTIMETERS',
  feetAndInches = 'IMPERIAL_FEET_INCHES',
}

export enum UnitOfTimeEnum {
  months = 'months',
  years = 'years',
}

export enum UnionStatusIndicatorEnum {
  noPreference = 'noPreference',
  specifyStatus = 'specifyStatus',
  member = 'member',
  nonMember = 'nonMember',
}

export enum WillingToEnum {
  hairColor = '14',
  hairStyle = '13',
  facialHair = '12',
  extrasWork = '4',
}

export enum SizesCategoryEnum {
  men = 'men',
  women = 'women',
  children = 'children',
}

export enum SizesChildrenCategoryEnum {
  boys = 'boys',
  girls = 'girls',
  toddlers = 'toddlers',
  infants = 'infants',
}

export type FilterData = {
  name: string;
  label: string;
};

export type RangeType = {
  switchTo: boolean;
  min: number | string;
  max: number | string;
  type: RangeEnum;
};

export type SelectOption = {
  value: ReactText | string[];
  label: ReactText;
  count?: number;
};

export type SelectRadioOption = {
  value: string | string[];
  label: string;
};

export interface FilterValues {
  [filter: string]: any;
}

export type ValueOf<T> = T[keyof T];

export type ChildrenProps = {
  isFilterSettingsModal: boolean;
  toggleFilterSettingsModal: () => void;
};

export interface FilterProps<Values = FilterValues> {
  showFilterSettingsButton?: boolean;
  showAdvancedSearchButton?: boolean;
  showBreadbox?: boolean;
  showFilterButton?: boolean;
  hideClearButton?: boolean;
  withFilterDrawer?: boolean;
  withMatchPath?: boolean;
  isCollapsed?: boolean;
  advancedSearchRoute?: string;
  matchPathValue?: string[];
  searchButtonLabel?: string;
  sessionStorageKey?: string;
  filtersLabel: { readonly [Key in keyof Values]: string };
  excludeValuesFromBreadbox?: string[];
  initialFilters: Values;
  appliedFilters: Values;
  onFiltersChange: (newFilters: Values) => void;
  onRetainedFiltersChange?: (newFilters: Values) => Values;
  children: (childrenProps: ChildrenProps) => JSX.Element;
  AboveFiltersFormComponent?: JSX.Element;
  BelowFiltersFormComponent?: JSX.Element;
  onNavigateAdvancedSearchRoute?: () => void;
  SaveSearchButton?: JSX.Element;
  className?: string;
}

export type GetAdditionalInitialFiltersArgs = {
  isSubmissionContext: boolean;
  accountOrgFeatures: Feature[];
  appliedFilters: FilterValues;
};

export type GetInitialRolePreferencesArgs = GetAdditionalInitialFiltersArgs;

export type CommonArgs = {
  roleDetails: Role;
};

export type GetProfileUnionFilterArgs = {
  unionStatusName: FilterData['name'];
  excludeUnionStatusName: FilterData['name'];
  profileSearchUnionFilterByRole: ProfileUnionFilter;
};

export type TalentUnionsArgs = {
  autofillByRoleCriteria: boolean;
  array: SelectOption[];
};

export type GetGenderAppearanceArgs = {
  genderName: FilterData['name'];
  additionallyIdentifiesAsName: FilterData['name'];
} & Omit<CommonArgs, 'name'>;

export type GetEthnicAppearanceArgs = CommonArgs;

export type GetPlayableAgeRangeArgs = {
  switchToName: FilterData['name'];
  ageMinName: FilterData['name'];
  ageMaxName: FilterData['name'];
} & Omit<CommonArgs, 'name'>;

export type GetWorkingLocationArgs = CommonArgs;

export interface CastingTalentSearchFilters {
  [FiltersNameEnum.stageName]: string;
  [FiltersNameEnum.talentType]: StringValueKeyOption[];
  [FiltersNameEnum.representativeList]: BasicStringValueOption[];
  [FiltersNameEnum.representatives]: BasicNumberValueOption[];
  [FiltersNameEnum.unionStatus]: BasicStringValueOption[];
  [FiltersNameEnum.gender]: StringValueFieldOption[];
  [FiltersNameEnum.additionallyIdentifiesAs]: StringValueFieldOption[]; // I think this doesn't get set anymore
  [FiltersNameEnum.ethnicAppearance]: BasicStringValueOption[];
  [FiltersNameEnum.playableAgeRange]: {
    [FiltersNameEnum.switchTo]: boolean;
    [FiltersNameEnum.min]: string;
    [FiltersNameEnum.max]: string;
    type: RangeEnum.age;
  };
  [FiltersNameEnum.workingLocation]: BasicStringValueOption[];
  [FiltersNameEnum.heightRange]: {
    [FiltersNameEnum.switchTo]: boolean;
    [FiltersNameEnum.min]: BasicStringValueOption;
    [FiltersNameEnum.max]: BasicStringValueOption;
    type: RangeEnum.height;
  };
  [FiltersNameEnum.weightRange]: {
    [FiltersNameEnum.switchTo]: boolean;
    [FiltersNameEnum.min]: BasicStringValueOption;
    [FiltersNameEnum.max]: BasicStringValueOption;
    type: RangeEnum.weight;
  };
}
